import React, { useContext } from "react";
import AppContext from "../../context/AppContext";
import CommonButton from "../common/CommonButton";
import ModalCloseButton from "../common/ModalCloseButton";
import translations from "../common/Translations";
import { Trash2 } from "lucide-react";
import { isRTL } from "../../utils/rtl";
const DeletePermission = ({
  isLoading,
  onClose,
  deleteFunction,
  onDeleteText,
  confirmText,
  confirmVariant,
  confirmTooltipText,
  zIndexClass = "z-[100]",
}) => {
  const { theme,langMode } = useContext(AppContext);
  const isRtl = isRTL(langMode);
  return (
    <div
      className={`fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 ${zIndexClass}`}
      dir={isRtl ? "rtl" : "ltr"}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div
        className={`
      relative bg-white rounded-2xl shadow-xl p-6 w-full max-w-md mx-4
      transform transition-all duration-300 ease-out
      ${theme === "dark"
            ? "dark-mode border border-red-500"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""}
    `}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <ModalCloseButton
          onClick={onClose}
          className={`absolute top-3 ${isRtl ? "left-3" : "right-3"}`}
        />
        <h3 className="text-lg font-semibold text-gray-800 text-center mt-2">
          {translations[langMode].confirmaction}
        </h3>
        <p className="text-sm text-gray-600 text-center mt-3 px-4 leading-relaxed">
          {onDeleteText}
        </p>
        <div className="flex justify-center items-center gap-3 mt-6">
          <CommonButton
            onClick={onClose}
            variant="outline"
            className="rounded-lg"
          >
            {translations[langMode].cancle}
          </CommonButton>
          <CommonButton colorIntent={confirmVariant ?? "danger"}
            type="submit"
            className={`
          rounded-lg
          ${isLoading ? "bg-opacity-60 cursor-not-allowed" : "bg-opacity-100"}
        `}
            onClick={deleteFunction}
            variant={confirmVariant ?? "primary"}
            disabled={isLoading}
          >
            <span className="inline-flex items-center gap-1.5">
              <Trash2 size={16} className="shrink-0" />
              <span>{isLoading ? translations[langMode].Processing : (confirmText ?? translations[langMode].delete)}</span>
            </span>
          </CommonButton> 
        </div>
      </div>
    </div>

  );
};

export default DeletePermission;
